<template lang="pug"></template>

<script>
export default {
    name: 'BotaoHome',
    componentOptions: {
        title: 'Home',
        actions: [
            [
                {
                    name: 'Início',
                    iconClass: 'lyra-icon lyra-home',
                    showView: false,
                    action: 'abrirHome',
                    route: 'Home',
                    nameTranslationKey: 'mensagens.menuLateral.inicio'
                }
            ]
        ]
    },

    methods: {
        abrirHome() {
            if (this.$route.name !== 'Home') {
                this.$router.push({ name: 'Home' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
